/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import { useState, Suspense, forwardRef, useContext, useEffect } from "react";
import {
	NexcalEmployeeLogo,
	PhcsLogo,
	QuestDiagonosticLogo,
	BrookshireLogo,
	CPLLogo,
	ShieldPoweredLOGO
} from "../../../../../assets";
import CustomDataGrid from "../../../../shared/customDataGrid/CustomDataGrid";
import { AuthContext } from "../../../../../contexts";
import { maskSSN } from "../../../../../constants/maskSSN";

import { Grid, Paper } from "@mui/material";
import QRCode from "react-qr-code";
import { getLocalIPV4 } from "../../../../../utils/commonFunctions/getLocalIP4";
import { MEMBER_ENV } from "../../../../../config/config";
import encryption from "../../../../../utils/commonFunctions/encryption";

import "./healthCardPrint.css";

const HealthCardPrintV3 = forwardRef(({ first_name, last_name, _ssn, group_number, _is_RX }, ref) => {
	// // console.log("first_name", props);
	const [urlLink, setUrlLink] = useState("");
	const [localIP, setLocalIP] = useState("");
	const { member } = useContext(AuthContext);

	// console.log("Member Details55555", member);
	const ssn = maskSSN(_ssn);
	// console.log("_ssn", _ssn);

	useEffect(() => {
		// eslint-disable-next-line arrow-parens
		getLocalIPV4().then((ip) => setLocalIP(ip));
	}, []);

	useEffect(() => {
		const { group_number, date_of_birth, SSN } = member;

		if (member) {
			const prodRedirectionLink = `https://www.nexcaliber.com/eligibility-check?gn=${group_number}&&qs=${encryption(
				SSN
			)}&&db=${encryption(date_of_birth)}`;

			if (member && (MEMBER_ENV === "PROD" || MEMBER_ENV === "DEV")) setUrlLink(prodRedirectionLink);
		}

		if (member && localIP) {
			const localRedirectionLink = `http:${localIP}:3002/eligibility-check?gn=${group_number}&&qs=${encryption(
				SSN
			)}&&db=${encryption(date_of_birth)}`;

			// const prodRedirectionLink = `www.nexcaliber.com/eligibility-check?gn=${group_number}&&qs=${encryption(
			// 	SSN
			// )}&&db=${encryption(date_of_birth)}`;

			if (member && MEMBER_ENV === "LOCAL") setUrlLink(localRedirectionLink);
			// if (member && (MEMBER_ENV === "PROD" || MEMBER_ENV === "DEV")) setUrlLink(prodRedirectionLink);
		}
	}, [member, localIP]);

	return (
		<div ref={ref}>
			<div className="employee-health-card-container">
				<div className="paper-form-container">
					<Paper className="theme-border-radius employee-print-paper-container" elevation={1}>
						<Grid container className="card-header-container">
							<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="group-logo">
								<img
									src={BrookshireLogo}
									alt="Brookshire-logo"
									style={{ width: "6rem", height: "6rem", marginTop: 6 }}
								/>
							</Grid>
							<Grid item xs={7} sm={7} md={7} lg={7} xl={7} className="health-card-content">
								<div className="employee-health-card-header">
									<span>BROOKSHIRE BROTHERS</span>
									<span>Employee Health & Dental Plan</span>
								</div>
								<div className="employee-health-card-sub-header">
									<span style={{ marginTop: 4 }}>Administrated by Nexcaliber</span>
									<span style={{ marginTop: 1 }}>Group #{member?.group_number}</span>
								</div>
								<div className="employee-health-card-sub-header">
									<span>Medical & Dental ID Card</span>
								</div>
								<div className="employee-health-border" style={{ width: "19rem" }} />
							</Grid>
							<Grid item xs={1} sm={1} md={1} lg={1} xl={1} className="group-logo">
								<div className="phcs-logo-container">
									<img
										src={PhcsLogo}
										style={{
											width: "5rem",
											height: "100%",
											marginLeft: "-3.5rem",
											marginTop: "2rem"
										}}
									/>
								</div>
							</Grid>
						</Grid>
						<Grid container className="employee-card-details-container">
							<Grid item xs={8} sm={8} md={8} lg={8} xl={8} style={{ marginTop: "0.5rem" }}>
								<div className="employee-details-container">
									<span>Employee ID Number:</span>
									<span style={{ marginLeft: "0.2rem" }}>XXX-XX-{ssn}</span>
								</div>
								<div style={{ marginTop: "0.1rem", fontSize: "0.7rem" }}>
									Please obtain missing digits from patient
								</div>
								<div
									className="employee-details-container"
									style={{ marginTop: "0.6rem", width: "16rem" }}
								>
									<span>Employee Name:</span>
									<span style={{ marginLeft: "0.2rem" }}>
										{member?.last_name.toUpperCase()}, {member?.first_name.toUpperCase()}
									</span>
								</div>
								{_is_RX == true && (
									<div>
										<div
											className="employee-details-container top-margin-two"
											style={{ marginTop: "1.5rem" }}
										>
											Prescription Drug Benefit with Shield:
										</div>
										<div className="container-border" style={{ width: "14rem" }} />
										{/* <div className="employee-details-container " style={{ marginTop: "0.5rem" }}>
											Generic $ 10.00 Co-payment
										</div> */}
										<div
											className="employee-details-container"
											style={{ fontWeight: "bolder", marginTop: "0.5rem" }}
										>
											<span>BIN:026556</span>
											<span style={{ marginLeft: "1.7rem" }}>Shield Phone: (877) 659-6101</span>
										</div>
										<div
											className="employee-details-container"
											style={{ fontWeight: "bolder", marginTop: "0.3rem" }}
										>
											<span>PCN:SHIELD</span>
											<span style={{ marginLeft: "1.5rem" }}>www.shieldpbm.com</span>
										</div>
									</div>
								)}
								{_is_RX == false && (
									<div style={{ marginTop: "1.5rem", fontSize: "0.75rem", lineHeight: "1.6" }}>
										<div style={{ textDecoration: "underline" }}>Prescription Drug Benefit:</div>
										<div>Generic $ 10.00 Co-payment</div>
										<div
											style={{
												display: "grid",
												gridTemplateColumns: "3.5rem 1fr",
												marginTop: "0.3rem"
											}}
										>
											<span>Brand</span>
											<div>
												<div>No Generic Available 50% or $ 10.00 minimum</div>
												<div>Generic Available Retail price minus $ 10.00</div>
											</div>
										</div>
									</div>
								)}
							</Grid>
							<Grid item xs={4} sm={4} md={4} lg={4} xl={4} style={{ marginTop: "-1.5rem" }}>
								<span
									className="qr-code-container"
									style={{
										position: "relative",
										padding: "0.4rem",
										marginTop: "2rem",
										marginLeft: "2rem",
										overflow: "hidden",
										display: "inline-block"
									}}
								>
									<QRCode
										size={256}
										style={{
											height: "5.5rem",
											maxWidth: "100%",
											width: "100%"
											// marginBottom: "-0.25rem"
										}}
										// value={"www.nexcaliber.com"}
										value={urlLink}
										fgColor="#4e4e4e"
										bgColor="#ffffff"
									/>
									{/* Top-left corner border */}
									<div
										className="corner-border top-left"
										style={{
											position: "absolute",
											top: 1,
											left: 1,
											width: "20px",
											height: "20px",
											borderTop: "2px solid #9c27b0",
											borderLeft: "2px solid #9c27b0"
										}}
									></div>

									{/* Top-right corner border */}
									<div
										className="corner-border top-right"
										style={{
											position: "absolute",
											top: 1,
											right: 1,
											width: "20px",
											height: "20px",
											borderTop: "2px solid #9c27b0",
											borderRight: "2px solid #9c27b0"
										}}
									></div>

									{/* Bottom-left corner border */}
									<div
										className="corner-border bottom-left"
										style={{
											position: "absolute",
											bottom: 1,
											left: 1,
											width: "20px",
											height: "20px",
											borderBottom: "2px solid #9c27b0",
											borderLeft: "2px solid #9c27b0"
										}}
									></div>

									{/* Bottom-right corner border */}
									<div
										className="corner-border bottom-right"
										style={{
											position: "absolute",
											bottom: 1,
											right: 1,
											width: "20px",
											height: "20px",
											borderBottom: "2px solid #9c27b0",
											borderRight: "2px solid #9c27b0"
										}}
									></div>
								</span>
								<div
									style={{
										fontWeight: "700",
										fontSize: "0.65rem",
										width: "8rem",
										textAlign: "center",
										marginLeft: "1rem"
									}}
								>
									Scan to check eligibility and benefits
								</div>
								{/* <div className="header-logo-container">
									<div className="phcs-logo-container">
										<img src={PhcsLogo} style={{ width: "6rem", height: "4.5rem" }} />
									</div>
									<div
										className="quest-logo-container container-border"
										style={{ marginBottom: "0.5rem" }}
									>
										<img src={CPLLogo} style={{ maxWidth: "fit-content", height: "2.5rem" }} />
									</div>
									<div className="logo-details employee-details-container">www.cpllabs.com</div>
								</div> */}
							</Grid>
							{_is_RX == true && (
								<Grid
									item
									xs={12}
									sm={12}
									md={12}
									lg={12}
									xl={12}
									className="group-logo"
									style={{ marginTop: "0.0rem" }}
								>
									<div
										className="spbm-logo-container"
										style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}
									>
										<img src={ShieldPoweredLOGO} style={{ width: "8rem", height: "100%" }} />
									</div>
								</Grid>
							)}
						</Grid>
						{/* <div
							className="employee-details-container"
							style={{ fontWeight: "bolder", marginTop: "0.7rem" }}
						>
							<span>Brand</span>
							<span style={{ marginLeft: "2rem" }}>No Generic Available 50% or $ 10.00 minimum</span>
						</div>
						<div className="employee-details-container" style={{ marginLeft: "4.4rem" }}>
							Generic Available Retail price minus $ 10.00
						</div> */}
					</Paper>
				</div>
			</div>
			<div className="employee-id-container" id="employee-id-container">
				<div className="paper-form-container">
					<Paper className="theme-border-radius employee-print-paper-container" elevation={1}>
						{/* <Grid container className="summary-benefits-header-container">
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								Summary of Benefits for Medical Plan
							</Grid>
						</Grid> */}
						{/* <Grid container className="summary-benefits-plan-container">
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								<Grid container>
									<Grid item xs={4} sm={4} md={4} lg={4} xl={4}></Grid>
									<Grid
										item
										xs={4}
										sm={4}
										md={4}
										lg={4}
										xl={4}
										style={{ textShadow: "0px 0.1px, 0.1px 0px, 0.1px 0.2px", letterSpacing: 0.5 }}
									>
										In Network
									</Grid>
									<Grid
										item
										xs={4}
										sm={4}
										md={4}
										lg={4}
										xl={4}
										style={{ textShadow: "0px 0.1px, 0.1px 0px, 0.1px 0.2px", letterSpacing: 0.5 }}
									>
										Out of Network
									</Grid>
								</Grid>
								<CustomDataGrid dataGrid={summaryBenefits} />
							</Grid>
						</Grid> */}
						{/* <div className="summary-benefits-footer-container"> */}
						<div
							className="header-logo-container"
							style={{ display: "flex", alignItems: "center", marginTop: "-1rem", marginLeft: "1rem" }}
						>
							<div className="phcs-logo-container">
								<img src={PhcsLogo} style={{ width: "7rem", height: "100%" }} />
							</div>
							<div className="quest-logo-container container-border" style={{ marginBottom: "0.5rem" }}>
								<img
									src={CPLLogo}
									style={{
										maxWidth: "fit-content",
										height: "3rem",
										marginLeft: "2rem",
										marginTop: "0.7rem"
									}}
								/>
							</div>
						</div>
						<div
							className="logo-details employee-details-container"
							style={{ fontWeight: "700", fontSize: "0.8rem", marginLeft: "13rem", marginTop: "-0.8rem" }}
						>
							www.cpllabs.com
						</div>
						{/* </div> */}

						<div className="summary-benefits-footer-container" style={{ fontSize: "1rem" }}>
							<div className="footer-border" style={{ marginBottom: "0.3rem" }} />
							<div className="footer-top-content-container" style={{ fontSize: "0.8rem" }}>
								<div>Precertification is required : </div>
								<div className="footer-top-sub-content" style={{ marginLeft: "4px" }}>
									Call Spectrum Services at (800) 258-5055
								</div>
							</div>
							<div
								className="footer-bottom-content"
								style={{ fontSize: "0.7rem", marginBottom: "0.3rem" }}
							>
								for any required precertification or prior plan approval of services
							</div>
							<div className="footer-border" />
							<div
								className="footer-bottom-content"
								style={{
									textShadow: "0px 0.5px, 0.5px 0px, 0.1px 0.2px",
									fontSize: "0.7rem",
									marginBottom: 0
								}}
							>
								For online claim access visit the Health Plan Portal
							</div>
							<div
								className="footer-bottom-content"
								style={{ textShadow: "0px 0.5px, 0.5px 0px, 0.1px 0.2px", fontSize: "0.7rem" }}
							>
								Webpage address is https://member.enrollment.nexcaliber.com
							</div>
							<div className="footer-border" style={{ marginBottom: "0.3rem" }} />
							<div
								className="footer-bottom-content"
								style={{ fontSize: "0.8rem", marginBottom: "0.3rem" }}
							>
								Mail all claims to: Nexcaliber , PO Box 802422, Dallas, Texas 75380
							</div>
							<div className="footer-logo-container" style={{ marginBottom: "-1.95rem" }}>
								<img src={NexcalEmployeeLogo} alt="Nexcal employee Logo" />
							</div>
							<div className="footer-content" style={{ marginLeft: "0rem" }}>
								Medical and Dental Benefit / Enrollment Questions and Verifications : Call Nexcaliber
								(800) 741-0185
							</div>
						</div>
					</Paper>
				</div>
			</div>
		</div>
	);
});

export default HealthCardPrintV3;
